// Mock data for InjuryFreeLiving website

export const brandName = "InjuryFreeLiving";
export const brandTagline = "Smart Healing Solutions";

export const heroData = {
  title: "WE ARE",
  subtitle: "INJURY FREE LIVING",
  description: "We create innovative products and technologies that drive advancements in",
  highlights: ["Wound Care", "Wound Closure", "Tissue Regeneration", "Scar Management"],
  image: "https://images.unsplash.com/photo-1758691461935-202e2ef6b69f?w=1200&q=80"
};

export const contactInfo = {
  helpline: "+918130444101",
  email: "care@injuryfreeliving.com",
  address: "Near Ganga Ram hospital old Rajender Nagar new delhi-110060, India"
};

export const productData = {
  title: "Advanced Negative Pressure Wound Therapy with a",
  highlight: "Difference",
  tagline: "Experience advanced NPWT by InjuryFreeLiving",
  description: "InjuryFreeLiving™ NPWT is an advanced negative pressure wound therapy system designed for faster healing. It enhances wound closure, reduces infection risk, and improves patient comfort with continuous and intermittent suction modes for optimal wound care management.",
  image: "https://images.unsplash.com/photo-1516549655169-df83a0774514?w=800&q=80",
  keyFeatures: [
    "Easy-to-operate, precise one-click pressure settings certified by NABL-accredited labs",
    "EMI/EMC-certified by globally renowned lab, meeting international safety standards",
    "Published clinical data on safety and performance",
    "Backed by reliable and responsive service support",
    "P.U. foam dressings are biocompatible in small, medium, and large sizes",
    "Visual and audible alarms for leak, block, canister full, and battery status"
  ],
  healingMechanisms: [
    {
      title: "Wound Contraction",
      description: "Creates a vacuum effect that gently pulls wound edges together, reducing wound size and speeding healing"
    },
    {
      title: "Microdeformation",
      description: "Strains healing tissues, promoting cell division, growth factor production, and angiogenesis"
    },
    {
      title: "Fluid Removal",
      description: "Removes excess fluid from the wound, reducing edema and improving blood flow"
    },
    {
      title: "Reduced Bacterial Colonization",
      description: "Provides a barrier that shields the wound from environmental contaminants"
    }
  ],
  indications: [
    {
      icon: "heart-pulse",
      title: "Acute Wound Healing",
      description: "Aids surgical incisions, traumatic injuries, and post-operative sites by speeding recovery"
    },
    {
      icon: "stethoscope",
      title: "Post-Surgery",
      description: "Surgical patients recover fast with reduced scarring"
    },
    {
      icon: "activity",
      title: "Complex Wounds",
      description: "Trusted to manage diverse wounds ensuring effective treatment and patient comfort"
    },
    {
      icon: "band-aid",
      title: "Traumatic Wounds",
      description: "Aids in the healing of traumatic wounds, resulting in improved cosmetic outcomes"
    },
    {
      icon: "shield-heart",
      title: "Chronic Wounds",
      description: "Patients with chronic conditions experience improved wound closure"
    },
    {
      icon: "sparkles",
      title: "Cosmetic Benefit",
      description: "Reducing scar visibility and enhancing cosmetic outcomes"
    }
  ],
  contraindications: [
    "Exposed vital organs",
    "Exposed blood vessels",
    "Malignant wounds",
    "Necrotic wounds with eschar",
    "Untreated osteomyelitis",
    "Untreated coagulopathy"
  ],
  badges: [
    { title: "Made in India", icon: "flag" },
    { title: "FDA Approved", icon: "shield-check" },
    { title: "Electrical Safety", icon: "zap" },
    { title: "Patent Protected Design", icon: "award" }
  ]
};

export const features = [
  { title: "Reliable", icon: "thumbs-up" },
  { title: "Effective", icon: "check-circle" },
  { title: "Seamless", icon: "refresh-cw" },
  { title: "Economical", icon: "dollar-sign" }
];

export const technologyFeatures = {
  title: "Precision-Controlled Advanced NPWT by",
  subtitle: "InjuryFreeLiving",
  tabs: [
    {
      id: "cutting-edge",
      label: "Cutting Edge Technology",
      features: [
        {
          icon: "gauge",
          title: "Accurate, Regulated Pressure",
          description: "Advanced PID controller continuously stabilizes pressure based on wound specifics, eliminating common fluctuations."
        },
        {
          icon: "git-branch",
          title: "Double Tubing",
          description: "Maintains optimal exudate removal and pressure, minimizing blockage risks."
        },
        {
          icon: "alert-circle",
          title: "Real-Time Leakage Monitoring",
          description: "Alerts with green, yellow, and red signals for proactive adjustments, reducing full-scale alarms."
        },
        {
          icon: "package",
          title: "Premium dressing kit",
          description: "Medical-grade foam & dual-drape dressing kit for optimal coverage, comfort, and accelerated healing."
        }
      ]
    },
    {
      id: "integrated-care",
      label: "Integrated Care EcoSystem",
      features: [
        {
          icon: "phone",
          title: "24/7 Helpline",
          description: "Expert support available anytime"
        },
        {
          icon: "refresh-cw",
          title: "Automatic Updates",
          description: "System-sent therapy progress to clinicians"
        },
        {
          icon: "users",
          title: "Professional Assistance",
          description: "Daily support from trained staff"
        },
        {
          icon: "video",
          title: "Video Guides",
          description: "Easy guidance for patients and caregivers"
        }
      ]
    },
    {
      id: "simplicity",
      label: "Designed for Simplicity",
      features: [
        {
          icon: "package",
          title: "Portable & Lightweight",
          description: "Ergonomic design and weight less than 1.5 kg"
        },
        {
          icon: "monitor",
          title: "Single-Screen Operation",
          description: "Real-time therapy information"
        },
        {
          icon: "car",
          title: "Car Charger Compatible",
          description: "Ideal for mobile patients"
        },
        {
          icon: "check-square",
          title: "Ease of Use",
          description: "Integrated canister for easy transport"
        }
      ]
    }
  ]
};

export const testimonials = [
  {
    name: "Sarah Mitchell",
    role: "Post-Surgery Patient",
    text: "The InjuryFreeLiving system transformed my recovery. The support team was available 24/7 and made the entire process seamless. Highly recommended!"
  },
  {
    name: "Dr. James Rodriguez",
    role: "Wound Care Specialist",
    text: "As a healthcare professional, I'm impressed by the precision and reliability of this system. My patients have experienced significantly faster healing times."
  },
  {
    name: "Emily Chen",
    role: "Chronic Wound Patient",
    text: "After struggling with chronic wounds for years, InjuryFreeLiving gave me hope. The treatment is comfortable, effective, and the staff truly cares about patient outcomes."
  }
];

export const aboutData = {
  mission: "We are driven by the mission to create innovative products and technologies for wound care, wound closure, tissue regeneration and scar management.",
  focus: "Our focus is on empowering doctors and nurses to deliver exceptional patient care through cutting-edge, high-quality medical devices that are both effective and affordable.",
  vision: "To be a new-age manufacturer of innovative, high-quality medical devices that enable healthcare professionals to deliver better care at accessible prices.",
  philosophy: "We believe that healthcare innovation should never come at the expense of accessibility and affordability. By continually streamlining our supply chain and operations, we ensure that our products remain fairly priced and accessible to those who need them most.",
  values: [
    {
      icon: "users",
      title: "People",
      description: "We prioritize ethics and respect the dignity of every individual."
    },
    {
      icon: "lightbulb",
      title: "Innovation",
      description: "Constantly pushing the boundaries of medical device design and functionality."
    },
    {
      icon: "award",
      title: "Quality",
      description: "Ensuring the highest standards in every product we create."
    },
    {
      icon: "dollar-sign",
      title: "Affordability",
      description: "Making advanced healthcare solutions accessible to all."
    },
    {
      icon: "heart",
      title: "Provider-Focused",
      description: "Building strong relationships with hospitals and clinicians to co-create meaningful solutions."
    },
    {
      icon: "target",
      title: "Outcome-Oriented",
      description: "Ensuring every product contributes to improved patient care and provider satisfaction."
    }
  ],
  stats: {
    wounds: "10.5 traumatic wounds per 1,000 individuals globally",
    diabetes: "400+ million diabetes cases projected by 2025",
    footUlcers: "25% of diabetic patients develop foot ulcers",
    amputation: "15% facing amputation risk"
  },
  foundation: {
    title: "InjuryFreeLiving Foundation",
    description: "We recognize that wounds are more than clinical challenges—they're deeply personal, affecting lives, routines, and confidence. Through the InjuryFreeLiving Foundation, we are committed to advancing healthcare education and supporting underserved communities."
  },
  image: "https://images.pexels.com/photos/5215017/pexels-photo-5215017.jpeg?w=600&q=80"
};

export const resourcesData = {
  news: [
    {
      title: "Cell-engineered technologies for wound healing and tissue regeneration",
      date: "October 24, 2025",
      source: "Medical Innovation Journal",
      image: "https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?w=400&q=80",
      link: "https://www.nature.com/articles/s44385-025-00042-w"
    },
    {
      title: "Clinical Study Confirms Faster Healing Times with Advanced NPWT",
      date: "February 28, 2025",
      source: "Healthcare Research Review",
      image: "https://images.unsplash.com/photo-1516549655169-df83a0774514?w=400&q=80",
      link: "https://pmc.ncbi.nlm.nih.gov/articles/PMC6852528/"
    },
    {
      title: "Innovation in Wound Management: A Game Changer for Patients",
      date: "January 10, 2025",
      source: "Medical Technology News",
      image: "https://images.pexels.com/photos/3845129/pexels-photo-3845129.jpeg?w=400&q=80",
      link: "https://www.biospectrumasia.com/opinion/30/14648/innovations-in-wound-care-to-improve-patient-outcomes-.html"
    }
  ],
  downloads: [
    {
      title: "Product Brochure",
      type: "PDF",
      size: "2.5 MB",
      description: "Comprehensive product catalog with features and specifications"
    },
    {
      title: "User Manual",
      type: "PDF",
      size: "5.8 MB",
      description: "Complete guide to operation, maintenance, and safety"
    },
    {
      title: "Clinical Studies",
      type: "PDF",
      size: "3.2 MB",
      description: "Research papers and clinical trial results"
    }
  ],
  clinicalStudies: [
    {
      title: "Clinical Outcomes of NPWT in Wound Healing",
      description: "Study highlights effectiveness of NPWT in improving healing scores across various wound types",
      image: "https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?w=600&q=80",
      link: "https://pmc.ncbi.nlm.nih.gov/articles/PMC10088847/"
    },
    {
      title: "Management of Post-Traumatic Wounds Using NPWT",
      description: "Clinical evidence demonstrating significant improvements in post-traumatic wound management",
      image: "https://images.pexels.com/photos/5215017/pexels-photo-5215017.jpeg?w=600&q=80",
      link: "http://www.casereports.in/articles/12/1/Management-of-Post-Traumatic-Wounds-using-Indigenously-Developed-Negative-Pressure-Wound-Therapy-Device.html"
    }
  ]
};

export const agencies = [
  { name: "Healthcare Innovation Alliance", icon: "building-2" },
  { name: "Medical Technology Institute", icon: "lightbulb" },
  { name: "Advanced Care Partners", icon: "activity" },
  { name: "Clinical Research Foundation", icon: "award" },
  { name: "Healthcare Excellence Network", icon: "trophy" },
  { name: "Medical Device Consortium", icon: "briefcase" }
];

export const footerData = {
  description: "We create innovative products and technologies that drive advancements in Wound Care, Wound Closure, Tissue Regeneration, and Scar Management",
  address: contactInfo.address,
  contact: {
    email: contactInfo.email,
    phone: contactInfo.helpline
  },
  links: [
    { label: "Home", path: "/" },
    { label: "Product", path: "/product" },
    { label: "About Us", path: "/about" },
    { label: "Resources", path: "/resources" },
    { label: "Contact", path: "/contact" }
  ],
  social: [
    { platform: "Facebook", icon: "facebook", url: "https://www.facebook.com/profile.php?id=61587148810352" },
    { platform: "Twitter", icon: "twitter", url: "#" },
    { platform: "LinkedIn", icon: "linkedin", url: "https://www.linkedin.com/company/injuryfreeliving" },
    { platform: "Instagram", icon: "instagram", url: "https://www.instagram.com/injuryfreeliving/" },
    { platform: "YouTube", icon: "youtube", url: "https://www.youtube.com/@InjuryFreeLiving" }
  ]
};
